import React, { createContext, useContext } from 'react';
import { brandingConfig, updateBrandingConfig as updateConfig } from '@/config/branding';

// Create the context with the default branding config
const BrandingContext = createContext(brandingConfig);

// Branding Provider component
export const BrandingProvider: React.FC<{ 
  children: React.ReactNode,
  config?: Partial<typeof brandingConfig>
}> = ({ children, config }) => {
  // Apply any custom config overrides if provided
  if (config) {
    const updatedConfig = { ...brandingConfig, ...config };
    updateConfig(updatedConfig);
  }

  return (
    <BrandingContext.Provider value={brandingConfig}>
      {children}
    </BrandingContext.Provider>
  );
};

// Custom hook to use the branding context
export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within a BrandingProvider');
  }
  return context;
};

// Simple component to access branding values without hooks
export const Branding = {
  get appName() {
    return brandingConfig.appName;
  },
  get shortName() {
    return brandingConfig.shortName;
  },
  get companyName() {
    return brandingConfig.companyName;
  },
  get tagline() {
    return brandingConfig.tagline;
  },
  get websiteUrl() {
    return brandingConfig.websiteUrl;
  },
  get supportUrl() {
    return brandingConfig.supportUrl;
  },
  get supportTitle() {
    return brandingConfig.supportTitle;
  },
  get colorTheme() {
    return brandingConfig.colorTheme;
  },
  get requiredEmailDomain() {
    return brandingConfig.requiredEmailDomain;
  }
};